<template>
  <div class="page__bd bm" id="audit">
  <toobarhead :showRefresh="false" :showBack="true" :titleName="'审核'" :showBackTip="true"></toobarhead>
  <form>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell  weui-cell_select weui-cell_select-after">
        <div class="weui-cell__hd">
          <label class="weui-label">审核结果</label>
        </div>
        <div class="weui-cell__bd">
          <select class="weui-select" v-model.number="sealOutFlow.auditResult">
            <option value="1">审核通过</option>
            <option value="0">审核不通过</option>
          </select>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">审核意见</label>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
            <textarea class="weui-textarea" placeholder="请输入文本" rows="6" v-model="sealOutFlow.content"></textarea>
            <div class="weui-textarea-counter"><span>{{contentNum}}</span>/200</div>
        </div>
      </div>
    </div>
    <div class="audit">
      <button  v-bind:class="[{'weui-btn_disabled': !showSubmitBtn}, 'weui-btn weui-btn_primary']" @click.prevent="audit">提交审核</button>
    </div>
  </form>
  <div id="dialogs">
      <!--BEGIN dialog1-->
    <div class="js_dialog" id="auditConfirmDlg" style="display: none;">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">确认审核</strong></div>
        <div class="weui-dialog__bd">确定提交当前审核吗</div>
        <div class="weui-dialog__ft">
          <a class="weui-dialog__btn weui-dialog__btn_default" @click.prevent="cancel">放弃</a>
          <a class="weui-dialog__btn weui-dialog__btn_primary" @click.prevent="submit">确定</a>
        </div>
      </div>
    </div>
  </div>
    <transition name="slide-fade">
      <div v-if='showAuditSuccessToast'>
        <div class="weui-toast">
          <i class="weui-icon-success-no-circle weui-icon_toast"></i>
          <p class="weui-toast__content">已完成</p>
        </div>
      </div>
    </transition>
    <div class="audit_loadingToast" v-show="showAuditOperateToast">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">操作中...</p>
      </div>
    </div>
    <div class="js_dialog" v-show="showTip">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">操作被终止</strong></div>
        <div class="weui-dialog__bd">{{tipContent}}</div>
        <div class="weui-dialog__ft">
            <a @click.prevent.stop='showTip=false' class="weui-dialog__btn weui-dialog__btn_primary">知道了</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import toobarhead from './head'
  import { mapGetters, mapActions } from 'vuex'
  import contractApi from '../api/contractApi'
  export default {
    data () {
      return {
        taskId: '',
        taskName: '',
        orderId: '',
        sealOutFlow: {
          content: '审核通过！',
          auditResult: 1,
          sealOutId: -1
        },
        contentNum: 0,
        showAuditOperateToast: false,
        showAuditSuccessToast: false,
        showSubmitBtn: false,
        showTip: false,
        tipContent: ''
      }
    },
    computed: {
      ...mapGetters([
        'currentSealOut'
      ]),
      isAuditPass () {
        if (this.currentSealOut && parseInt(this.sealOutFlow.auditResult) === 1) { // 审核通过
          return true
        }
        return false
      }
    },
    watch: {
      'sealOutFlow.content': function (val) {
        let len = val.length
        this.contentNum = len
        if (len > 200) {
          this.content = val.substring(0, 200)
        }
        if (window.$.trim(len) > 0 && this.sealOutFlow.auditResult > -1) {
          this.showSubmitBtn = true
        } else {
          this.showSubmitBtn = false
        }
      },
      'sealOutFlow.auditResult': function (val) {
        if (this.sealOutFlow.auditResult > -1 && window.$.trim(this.sealOutFlow.content).length > 0) {
          this.showSubmitBtn = true
        } else {
          this.showSubmitBtn = false
        }
        if (val === 0) {
          this.sealOutFlow.content = ''
        } else {
          this.sealOutFlow.content = '审核通过！'
        }
      }
    },
    mounted: function () {
      let route = this.$route
      this.$nextTick(function () {
        let vm = this
        this.taskId = route.query.taskId
        this.taskName = route.query.taskName
        this.orderId = route.query.orderId
        this.sealOutFlow.sealOutId = route.params.sealOutId
        if (vm.currentSealOut === null) {
          vm.findSealOut({
            id: route.params.sealOutId,
            data: {
              op: 'audit',
              orderId: route.query.orderId,
              taskId: route.query.taskId,
              taskName: route.query.taskName
            }
          }).then(c => { // 获取到当前合同信息后进行处理
            vm.showSubmitBtn = true
          }).catch(errMsg => {
            vm.tipContent = errMsg + ', 请刷新列表后再试'
            vm.showTip = true
          })
        } else {
          vm.showSubmitBtn = true
        }
      })
    },
    methods: {
      ...mapActions([
        'findSealOut'
      ]),
      goBack: function () {
        let vm = this
        setTimeout(function () {
          vm.$router.push({
            path: '/listSealOut/audit',
            query: {
              showNavbar: true,
              showBack: false,
              tname: '印章信息',
              refresh: true,
              selected: 0
            }
          })
        }, 200)
      },
      audit: function () {
        if (!this.showSubmitBtn) {
          return
        }
        window.$('#audit #auditConfirmDlg').fadeIn(200)
      },
      parepare () { // 为跟电脑端数据结构保持一致，先做一个数据转换
        let data = {
          'orderId': this.orderId,
          'taskId': this.taskId,
          'taskName': this.taskName,
          'auditResult': this.sealOutFlow.auditResult,
          'sealOutFlow.sealOutId': this.sealOutFlow.sealOutId,
          'sealOutFlow.comment': this.sealOutFlow.content.trim().replace(/\n|\r\n/g, '<br/>')
        }
        return data
      },
      submitBack () { // 提交返回后公共处理部分
        let vm = this
        vm.cancel()
        vm.showAuditOperateToast = false
        vm.showSubmitBtn = true
      },
      submit () {
        let vm = this
        if (vm.showAuditOperateToast || !vm.showSubmitBtn) {
          return
        }
        vm.showAuditOperateToast = true
        vm.showSubmitBtn = false
        contractApi.auditSealOut(vm.parepare(), () => {
          vm.submitBack()
          vm.showAuditSuccessToast = true
          setTimeout(function () {
            vm.showAuditSuccessToast = false
            setTimeout(function () {
              vm.goBack()
            }, 400)
          }, 500)
        }, (errMsg) => {
          vm.submitBack()
          vm.tipContent = errMsg
          vm.showTip = true
        })
      },
      cancel: function () {
        window.$('#audit #auditConfirmDlg').fadeOut(200)
      }
    },
    components: {
      toobarhead
    }
  }
</script>
<style>
  .audit {
    margin: 30px auto;
    width: 80%;
  }
  .slide-fade-enter-active {
    transition: all .6s ease;
  }
  .slide-fade-leave-active {
    transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-active {
    padding-left: 10px;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// auditSealOut.vue?bc0f0b42